import constants from './constants'
import _ from 'lodash'

/**
 * Converts a fixed color name like red-medium to a hex code (including the
 * preceding #). If the name is not recognized, it is returned as is.
 * @param {string} name a fixed color name like red-medium
 * @return {string}
 */
function nameToHex(name) {
	let hexCode = constants.scoreColors[name]?.hexCode
	return hexCode ? `#${hexCode}` : name
}

/**
 * Converts an array of fixed color names to an array of hex codes. If one of
 * the names is not recognized, it is returned as is.
 * @param {string[]} names
 * @return {string[]}
 */
function namesToHex(names) {
	return _.map(names, nameToHex)
}

export const TURQUOISE_DARK = '#00A9C3'
export const TURQUOISE_MEDIUM = '#60CBDB'
export const BLUE_LIGHT = '#CDE9FA'
export const BLUE_DARK = '#0074BB'
export const BLUE_MEDIUM = '#1A94DA'
export const TURQUOISE_LIGHT = '#CCF3F9'
export const PERIWINKLE_DARK = '#3654D4'
export const PERIWINKLE_MEDIUM = '#839AFF'
export const PERIWINKLE_LIGHT = '#C4CFFF'
export const PURPLE_DARK = '#6D1DB8'
export const PURPLE_MEDIUM = '#AD5AFA'
export const PURPLE_LIGHT = '#DBB5FF'
export const FUCHSIA_DARK = '#A31DB8'
export const FUCHSIA_MEDIUM = '#E55BFA'
export const FUCHSIA_LIGHT = '#F5B5FF'
export const RED_DARK = '#C93C20'
export const RED_MEDIUM = '#F25131'
export const RED_LIGHT = '#F7A695'
export const ORANGE_DARK = '#EB6600'
export const ORANGE_MEDIUM = '#FF8800'
export const ORANGE_LIGHT = '#FFC889'
export const YELLOW_DARK = '#EBB000'
export const YELLOW_MEDIUM = '#FBCC3B'
export const YELLOW_LIGHT = '#FBE499'
export const GREEN_DARK = '#619900'
export const GREEN_MEDIUM = '#96CD00'
export const GREEN_LIGHT = '#CAE779'
export const GRAY_DARKER = '#2D3640'
export const GRAY_DARK = '#8E9699'
export const GRAY_MEDIUM = '#BCC2C4'
export const GRAY_LIGHT = '#D7DEE0'
export const GRAY = '#EDEDED'
export const SLATE = '#98A3B3'
export const INFANTRY_BLUE = '#ABBFD8'
export const WHITE = '#FFFFFF'
export { nameToHex, namesToHex }
